module.exports = __webpack_public_path__ + "img/evx.5633c984.svg";